const windowType: any = { ...window };
const windowEnv = windowType._env_;

let REACT_APP_BACKEND = "";

function isValidUrl(string: string) {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
}

function normalizeUrl(base: string, path: string) {
  if (!base.endsWith("/")) {
    base += "/";
  }
  if (path.startsWith("/")) {
    path = path.substring(1);
  }
  let finalUrl = base + path;
  if (!finalUrl.endsWith("/")) {
    finalUrl += "/";
  }
  return finalUrl;
}

if (windowEnv && windowEnv.REACT_APP_BASE_MS_GW_API) {
  if (isValidUrl(windowEnv.REACT_APP_BASE_MS_GW_API)) {
    REACT_APP_BACKEND = windowEnv.REACT_APP_BASE_MS_GW_API;
  } else {
    REACT_APP_BACKEND = normalizeUrl(
      window.location.origin,
      windowEnv.REACT_APP_BASE_MS_GW_API
    );
  }
} else if (
  process.env.REACT_APP_BASE_MS_GW_API !== "undefined" &&
  process.env.REACT_APP_BASE_MS_GW_API
) {
  if (isValidUrl(process.env.REACT_APP_BASE_MS_GW_API)) {
    REACT_APP_BACKEND = process.env.REACT_APP_BASE_MS_GW_API;
  } else {
    REACT_APP_BACKEND = normalizeUrl(
      window.location.origin,
      process.env.REACT_APP_BASE_MS_GW_API
    );
  }
} else {
  REACT_APP_BACKEND = window.location.origin;
}

export const REACT_APP_HOST_BACKEND = normalizeUrl(REACT_APP_BACKEND, "");
